import http, { prefixUrlBiz } from './index'
const apis = {
  // 发票导出
  getDocument(data) {
    return http(`/${prefixUrlBiz}/api/document?documentKey=${data.documentKey}`, {
      method: 'get',
      data
    })
  },

  // 发票导出
  getDocumentBlob(data) {
    return http(`/${prefixUrlBiz}/api/document/byte?documentKey=${data.documentKey}`, {
      method: 'get',
      data
    })
  }
}

export default apis
